import { Encrypt3des, Decrypt3des, SignExtension } from '@/api/desEncrypt'
// let headers = SignExtension()
export function GetOptions (data, apiPath) {
    return {
        method: 'GET',
        params: data,
        headers: {
            ...SignExtension()
        },
        url: apiPath,
    }
}

export function PostOptions (data, apiPath) {
    return {
        method: 'POST',
        data: {
            data: Encrypt3des(data)
        },
        headers: {
            ...SignExtension()
        },
        url: apiPath,
    }
}
//图片
export function PostOptions2 (data, apiPath) {
    return {
        method: 'POST',
        data: data,
        headers: {
            ...SignExtension(),
            'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        url: apiPath,
    }
}
